import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TranslatePipe} from "@ngx-translate/core";
import {Component, inject, Input, OnInit} from "@angular/core";
import {InputComponent} from "../../../shared/form/input/input.component";
import {NameDataInfoDto} from "../../../models/student-ticket/list-view/NameDataInfoDto";
import {AbstractFormModalComponent} from "../../../shared/modal/abstract-form-modal.component";
import {ModalShellComponent} from "../../../shared/modal/modal-shell/modal-shell.component";

interface NameDetailsForm {
  firstName: FormControl<string | null>;
  lastName: FormControl<string | null>;
}

@Component({
  selector: 'app-name-details-adjust-modal',
  templateUrl: './name-details-adjust-modal.component.html',
  styleUrls: ['./name-details-adjust-modal.component.scss'],
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    InputComponent,
    ModalShellComponent
  ],
  standalone: true
})
export class NameDetailsAdjustModalComponent extends AbstractFormModalComponent implements OnInit {

  @Input() nameDetails: NameDataInfoDto;

  protected form: FormGroup<NameDetailsForm>;
  protected validationErrorKey = 'NAME_DATA.VALIDATION_ERROR';

  private readonly fb = inject(FormBuilder);

  ngOnInit(): void {
    this.form = this.fb.group({
      firstName: new FormControl(this.nameDetails.firstName, [Validators.required]),
      lastName: new FormControl(this.nameDetails.lastName, [Validators.required]),
    });
  }

  protected getCloseValue(): unknown {
    return this.form.value;
  }
}
